import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface ReopenPositionProps extends ButtonProps {}

export const ReopenPosition = (props: ReopenPositionProps) => {
  const { selectedPositionsCount, isOnlyActivePositionsSelected } = useTableInstanceContext();

  const noPositionSelected = selectedPositionsCount === 0;
  const onlyActivePositionsSelected = isOnlyActivePositionsSelected();
  const isDisabled = noPositionSelected || onlyActivePositionsSelected;

  const tooltipProps = useToolbarButtonTooltip("reopen");

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "rotate-right",
        title: "rotate-right"
      }}
      modifier="secondary"
      tooltipProps={tooltipProps}
    >
      {appstr("Reopen")}
    </Button>
  );
};
